"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var brand_code_checkbox_group_connected_1 = require("../checkbox/brand-code-checkbox-group.connected");

var multisource_code_checkbox_group_connected_1 = require("../checkbox/multisource-code-checkbox-group.connected");

var days_supply_selector_connected_1 = require("../days-supply-selector.connected");

var dispensing_fee_field_connected_1 = require("../dispensing-fee-field.connected");

var effective_date_field_connected_1 = require("../effective-date-field.connected");

var offset_percent_field_connected_1 = require("../offset-percent-field.connected");

var offset_type_selector_connected_1 = require("../offset-type-selector.connected");

var rule_details_1 = require("../rule-details");

var OffsetPercentPlusDispensingFeeTemplate = function (_super) {
  __extends(OffsetPercentPlusDispensingFeeTemplate, _super);

  function OffsetPercentPlusDispensingFeeTemplate() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  OffsetPercentPlusDispensingFeeTemplate.prototype.render = function () {
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.flexRow
    }, react_1.default.createElement(brand_code_checkbox_group_connected_1.ConnectedBrandCodeCheckboxGroup, null), react_1.default.createElement(multisource_code_checkbox_group_connected_1.ConnectedMultiSourceCodeCheckboxGroup, null)), react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.flexRow
    }, react_1.default.createElement(days_supply_selector_connected_1.ConnectedDaysSupplySelector, null)), react_1.default.createElement(rule_details_1.ColoredLine, null), react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.flexRow
    }, react_1.default.createElement(dispensing_fee_field_connected_1.ConnectedDispensingFee, null), react_1.default.createElement(offset_percent_field_connected_1.ConnectedOffsetPercent, null)), react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.flexRow
    }, react_1.default.createElement(offset_type_selector_connected_1.ConnectedOffsetSelector, null), react_1.default.createElement(effective_date_field_connected_1.ConnectedEffectiveDate, null)));
  };

  return OffsetPercentPlusDispensingFeeTemplate;
}(react_1.default.Component);

exports.OffsetPercentPlusDispensingFeeTemplate = OffsetPercentPlusDispensingFeeTemplate;